module.exports = __webpack_public_path__ + "assets/img/test2.ee9132f7.svg";